export enum TenderType {
  Cash = 'Cash',
}
